import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/insider-down.svg";
var InsiderDownOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  InsiderDownOutline_default as default
};
